import { memo, useCallback } from 'react';
import { Plus, Check, X, Play } from 'lucide-react';
import { USERS } from '../constants';

export const Header = memo(({ user, setUser, ideaInput, setIdeaInput, showIdea, setShowIdea, onQuickAdd }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      onQuickAdd();
    }
  }, [onQuickAdd]);

  const handleCancel = useCallback(() => {
    setShowIdea(false);
    setIdeaInput('');
  }, [setShowIdea, setIdeaInput]);

  return (
    <header className="bg-white border-b border-slate-200 px-4 md:px-6 py-3 md:py-4 flex-shrink-0">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 md:gap-4 min-w-0">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg shadow-violet-200 flex-shrink-0">
            <Play className="w-5 h-5 md:w-6 md:h-6 text-white" />
          </div>
          <div className="min-w-0">
            <h1 className="font-bold text-lg md:text-xl text-slate-800 truncate">Content Tracker</h1>
            <p className="text-xs md:text-sm text-slate-500 hidden sm:block">Manage your content pipeline</p>
          </div>
        </div>

        <div className="flex items-center gap-2 md:gap-4 flex-shrink-0">
          {/* User Toggle */}
          <div className="flex bg-slate-100 rounded-xl p-1">
            {USERS.map(u => (
              <button
                key={u}
                onClick={() => setUser(u)}
                className={`px-3 md:px-5 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-semibold capitalize transition ${
                  user === u ? 'bg-white shadow text-slate-900' : 'text-slate-500 hover:text-slate-700'
                }`}
              >
                {u}
              </button>
            ))}
          </div>

          {/* Quick Add */}
          {showIdea ? (
            <div className="flex items-center gap-2">
              <input
                autoFocus
                value={ideaInput}
                onChange={(e) => setIdeaInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Type idea..."
                className="w-36 md:w-72 px-3 md:px-4 py-2 md:py-2.5 border-2 border-violet-300 rounded-xl text-sm focus:outline-none focus:border-violet-500"
              />
              <button
                onClick={onQuickAdd}
                className="p-2 md:p-2.5 bg-violet-600 text-white rounded-xl hover:bg-violet-700"
              >
                <Check className="w-4 h-4 md:w-5 md:h-5" />
              </button>
              <button
                onClick={handleCancel}
                className="p-2 md:p-2.5 bg-slate-200 text-slate-600 rounded-xl hover:bg-slate-300"
              >
                <X className="w-4 h-4 md:w-5 md:h-5" />
              </button>
            </div>
          ) : (
            <button
              onClick={() => setShowIdea(true)}
              className="flex items-center gap-2 px-3 md:px-5 py-2 md:py-2.5 bg-violet-600 text-white rounded-xl hover:bg-violet-700 text-sm font-semibold shadow-lg shadow-violet-200"
            >
              <Plus className="w-5 h-5" />
              <span className="hidden sm:inline">Add Idea</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
});

Header.displayName = 'Header';
